import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77a388b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "createRecord" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "新建学生上课记录", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 识别 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("   至   ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" (单位：分钟) ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 确定 ")

import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { stuDist } from "../../config/interface";
import type { ElForm } from "element-plus";
type FormInstance = InstanceType<typeof ElForm>;


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const ruleFormRef = ref<FormInstance>();
const router = useRouter();
const route = useRoute();
const btnLoading = ref(false);
let back = "<";
let quickCont = ref("");
let recordInfo = ref({});
// 表单校验规则
const rules = {
  startTime: [
    {
      required: true,
      message: "请选择学习时间",
      trigger: "blur",
    },
  ],
  duration: [
    {
      required: true,
      message: "请输入学习时长",
      trigger: "blur",
    },
  ],
};
const handleDistinguish = () => {
  btnLoading.value = true;
	stuDist({posRecord:quickCont.value}).then((res)=>{
		console.log(res);
		btnLoading.value = false;
	})
};
const handleCreateRecord = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      console.log(recordInfo.value);
    } else {
      console.log("error submit!");
      return false;
    }
  });
};
const handleBack = () => {
  router.back();
};
onMounted(() => {
  console.log(route.params);
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "back",
        onClick: handleBack
      }, _toDisplayString(_unref(back)) + " 返回", 1)
    ]),
    _hoisted_3,
    _createVNode(_component_el_form, {
      ref_key: "ruleFormRef",
      ref: ruleFormRef,
      rules: rules,
      model: _unref(recordInfo),
      "label-width": "100px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "智能识别" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(quickCont),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(quickCont) ? (quickCont).value = $event : quickCont = $event)),
              type: "textarea",
              autosize: "",
              style: {"width":"350px"},
              placeholder: "可粘贴信息，系统智能识别"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              type: "primary",
              style: {"width":"80px","margin-left":"10px"},
              loading: btnLoading.value,
              onClick: handleDistinguish
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "上课时间",
          prop: "startTime"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              modelValue: _unref(recordInfo).startTime,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(recordInfo).startTime) = $event)),
              type: "datetime",
              placeholder: "请选择开始时间"
            }, null, 8, ["modelValue"]),
            _hoisted_5,
            _createVNode(_component_el_date_picker, {
              modelValue: _unref(recordInfo).endTime,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(recordInfo).endTime) = $event)),
              type: "datetime",
              placeholder: "请选择结束时间"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "上课时长",
          prop: "duration"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(recordInfo).duration,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(recordInfo).duration) = $event)),
              placeholder: "请输入上课时长",
              style: {"width":"220px"}
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              type: "text",
              size: "small",
              style: {"margin-left":"10px"}
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "本课知识点" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(recordInfo).point,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(recordInfo).point) = $event)),
              type: "textarea",
              autosize: "",
              style: {"width":"350px"},
              placeholder: "请输入本次课程的知识点"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "课程感受" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(recordInfo).feel,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(recordInfo).feel) = $event)),
              type: "textarea",
              autosize: "",
              style: {"width":"350px"},
              placeholder: "请输入本次课程感受"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "作业完成情况" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(recordInfo).work,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(recordInfo).work) = $event)),
              type: "textarea",
              autosize: "",
              style: {"width":"350px"},
              placeholder: "请输入上次课程的作业完成情况"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "其他疑问点" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(recordInfo).others,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(recordInfo).others) = $event)),
              type: "textarea",
              autosize: "",
              style: {"width":"350px"},
              placeholder: "请输入本次课程的其他疑问点"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "评价" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(recordInfo).evaluation,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(recordInfo).evaluation) = $event)),
              type: "textarea",
              autosize: "",
              style: {"width":"350px"},
              placeholder: "请输对入研究生的评价"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.dialogVisible = false))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (handleCreateRecord(ruleFormRef.value)))
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})